import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacing.space12};
`;
